"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileExtensions2ToIcon = {
  'gemfile.lock': 'file_type_bundler.svg',
  'css.map': 'file_type_cssmap.svg',
  'js.flow': 'file_type_flow.svg',
  'js.map': 'file_type_light_jsmap.svg',
  'layout.html': 'file_type_layout.svg',
  'layout.htm': 'file_type_layout.svg',
  'marko.js': 'file_type_markojs.svg',
  'story.js': 'file_type_storybook.svg',
  'story.jsx': 'file_type_storybook.svg',
  'story.ts': 'file_type_storybook.svg',
  'story.tsx': 'file_type_storybook.svg',
  'stories.js': 'file_type_storybook.svg',
  'stories.jsx': 'file_type_storybook.svg',
  'stories.ts': 'file_type_storybook.svg',
  'stories.tsx': 'file_type_storybook.svg',
  'test.js': 'file_type_light_testjs.svg',
  'test.jsx': 'file_type_light_testjs.svg',
  'test.mjs': 'file_type_light_testjs.svg',
  'spec.js': 'file_type_light_testjs.svg',
  'spec.jsx': 'file_type_light_testjs.svg',
  'spec.mjs': 'file_type_light_testjs.svg',
  'test.ts': 'file_type_testts.svg',
  'test.tsx': 'file_type_testts.svg',
  'spec.ts': 'file_type_testts.svg',
  'spec.tsx': 'file_type_testts.svg',
  'd.ts': 'file_type_typescriptdef.svg'
};